import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendMutationUnauthorizeChannelArgs,
  BackendPerformanceCenterIntegrationAccount,
} from 'src/types/backend';

import { FRAGMENT_INTEGRATION_ACCOUNT } from './schema';

const MUTATION = gql`
  mutation UnauthorizeChannel($channel: String!, $customerId: ID!) {
    unauthorizeChannel(channel: $channel, customerId: $customerId) {
      ...PerformanceCenterIntegrationAccount
    }
  }
  ${FRAGMENT_INTEGRATION_ACCOUNT}
`;

type Variables = BackendMutationUnauthorizeChannelArgs;
type Result = BackendPerformanceCenterIntegrationAccount[];

export const unauthorizeChannel = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
